import { render, staticRenderFns } from "./addnew_production.vue?vue&type=template&id=49f83a2e&"
import script from "./addnew_production.vue?vue&type=script&lang=js&"
export * from "./addnew_production.vue?vue&type=script&lang=js&"
import style0 from "./addnew_production.vue?vue&type=style&index=0&id=49f83a2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports